import { gql } from '@apollo/client'

export const STORE_ADDRESS_FRAGMENT = gql`
  fragment StoreAddress on Address {
    address1
    address2
    city
    state
    postalCode
  }
`
